import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lsi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getUser() {
    try { return JSON.parse(localStorage.getItem("lsi_user") || "null"); }
    catch { return null; }
  },
  setSession(token, user) {
    localStorage.setItem("lsi_token", token);
    localStorage.setItem("lsi_user", JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem("lsi_token");
    localStorage.removeItem("lsi_user");
  },
  isAuthed() { return !!localStorage.getItem("lsi_token"); },
};

// Public enquiry submit
export async function submitEnquiry(payload) {
  const { data } = await api.post("/enquiries", payload);
  return data;
}

// Runtime site settings (used for WhatsApp link before/without context)
export const runtime = { whatsapp: "917980074801" };

export function waLink(message) {
  const text = encodeURIComponent(message || "Hi, I would like to enquire about a loan/financial product.");
  return `https://wa.me/${runtime.whatsapp}?text=${text}`;
}

export async function getSettings() {
  const { data } = await api.get("/settings");
  return data;
}
